import { render, staticRenderFns } from "./Sede.vue?vue&type=template&id=1bd0c927&"
import script from "./Sede.vue?vue&type=script&lang=ts&"
export * from "./Sede.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports